import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SeniorLivingHealthcarePage = lazy(() => import('../pages/senior-living-healthcare/page'));
const WorkPage = lazy(() => import('../pages/work/page'));
const TeamPage = lazy(() => import('../pages/team/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TradePartnersPage = lazy(() => import('../pages/trade-partners/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/senior-living-healthcare-construction',
    element: <SeniorLivingHealthcarePage />,
  },
  {
    path: '/work',
    element: <WorkPage />,
  },
  {
    path: '/team',
    element: <TeamPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/trade-partners',
    element: <TradePartnersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
